import dayjs from "dayjs";

import { PeriodOptionType, Timespan } from "./types";

export const getTimespanFromPeriod = (period: PeriodOptionType): Timespan => {
  // To ensure data is available, we only show data up to one week ago.
  // This can be overridden by using the "custom" option, but may not be reliable.
  const now = dayjs();
  const sevenDaysAgo = now.subtract(7, "days");
  const prevMonth = now.subtract(1, "month");
  switch (period) {
    case "last_day":
      return {
        startDate: sevenDaysAgo.startOf("day"),
        endDate: sevenDaysAgo.endOf("day"),
      };
    case "last_7_days":
      return {
        startDate: sevenDaysAgo.subtract(6, "day").startOf("day"),
        endDate: sevenDaysAgo.endOf("day"),
      };

    case "last_28_days":
      return {
        startDate: sevenDaysAgo.subtract(27, "day").startOf("day"),
        endDate: sevenDaysAgo.endOf("day"),
      };
    case "last_18_months":
      return {
        startDate: now.subtract(18, "month").startOf("day"),
        endDate: sevenDaysAgo.endOf("day"),
      };
    case "prev_month":
      return {
        startDate: prevMonth.startOf("month"),
        endDate: prevMonth.endOf("month"),
      };
  }
  return {
    startDate: sevenDaysAgo.startOf("day"),
    endDate: sevenDaysAgo.endOf("day"),
  };
};
